import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  stepOneSharedData: any;
  stepTwoSharedData: any;
  stepThreeSharedData: any;
  stepFourSharedData: any;
  stepFiveSharedData: any;
  stepSixSharedData: any;

  stepThreeSharedDataCoOwnerNames: any;
  stepThreeSharedDataClosing: any;
  stepThreeSharedDataPurchases: any;
  stepThreeSharedDataSales: any;
  stepSixSharedDataCoOwnerSignatures: any;
  stepFiveSharedDataDocuments: any;

  completedStatusData: any;

  private dataSubject = new Subject<boolean>();

  sendData(data: boolean) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  }
  constructor() { }
}
